<div class="flow-shell">
    <header class="flow-header">
        <button *ngIf="pageHistory.length > 0" nz-button nzType="default" class="flow-header__back" (click)="goBack()">
            <span nz-icon nzType="arrow-left"></span>
            Back
        </button>
        <div class="flow-header__meta">
            <h1>Starlink Sales Flow</h1>
            <p>Current step: {{ currentStepLabel }}</p>
        </div>
    </header>

    <section *ngIf="hasCustomerInfo" class="customer-info-section">
        <nz-card>
            <div class="customer-info-header">
                <h3>Customer Information</h3>
            </div>
            <div class="customer-info-content">
                <div class="customer-chip" *ngIf="customerInfo.firstName">
                    <span class="chip-label">First Name:</span>
                    <span class="chip-value">{{ customerInfo.firstName }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy First Name" (click)="copyField(customerInfo.firstName, 'First Name')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="customerInfo.lastName">
                    <span class="chip-label">Last Name:</span>
                    <span class="chip-value">{{ customerInfo.lastName }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy Last Name" (click)="copyField(customerInfo.lastName, 'Last Name')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="customerInfo.address">
                    <span class="chip-label">Address:</span>
                    <span class="chip-value">{{ customerInfo.address }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy Address" (click)="copyField(customerInfo.address, 'Address')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="customerInfo.city">
                    <span class="chip-label">City:</span>
                    <span class="chip-value">{{ customerInfo.city }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy City" (click)="copyField(customerInfo.city, 'City')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="customerInfo.state">
                    <span class="chip-label">State:</span>
                    <span class="chip-value">{{ customerInfo.state }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy State" (click)="copyField(customerInfo.state, 'State')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="customerInfo.zip">
                    <span class="chip-label">ZIP:</span>
                    <span class="chip-value">{{ customerInfo.zip }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy ZIP" (click)="copyField(customerInfo.zip, 'ZIP')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="customerInfo.phone">
                    <span class="chip-label">Phone:</span>
                    <span class="chip-value">{{ customerInfo.phone }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy Phone" (click)="copyField(customerInfo.phone, 'Phone')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="customerInfo.email">
                    <span class="chip-label">Email:</span>
                    <span class="chip-value">{{ customerInfo.email }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy Email" (click)="copyField(customerInfo.email, 'Email')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="customerInfo.dob">
                    <span class="chip-label">Date of Birth:</span>
                    <span class="chip-value">{{ customerInfo.dob }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy Date of Birth" (click)="copyField(customerInfo.dob, 'Date of Birth')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="fullData.catalog?.reservedSku">
                    <span class="chip-label">Reserved SKU:</span>
                    <span class="chip-value">{{ fullData.catalog.reservedSku.label }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy Reserved SKU" (click)="copyField(fullData.catalog.reservedSku.sku, 'Reserved SKU')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="fullData.ihsOrder?.ihsOrderNumber">
                    <span class="chip-label">IHS Order Number:</span>
                    <span class="chip-value">{{ fullData.ihsOrder?.ihsOrderNumber }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy IHS Order Number" (click)="copyField(fullData.ihsOrder?.ihsOrderNumber, 'IHS Order Number')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>

                <div class="customer-chip" *ngIf="fullData.starlinkOrder?.starlinkOrderNumber">
                    <span class="chip-label">Starlink Order Number:</span>
                    <span class="chip-value">{{ fullData.starlinkOrder?.starlinkOrderNumber }}</span>
                    <button nz-button nzType="default" nzSize="default" class="chip-copy-btn" nz-tooltip
                        nzTooltipTitle="Copy Starlink Order Number" (click)="copyField(fullData.starlinkOrder?.starlinkOrderNumber, 'Starlink Order Number')">
                        <span nz-icon nzType="copy" nzTheme="outline"></span>
                    </button>
                </div>
            </div>
        </nz-card>
    </section>

    <nz-progress class="flow-progress" nzStrokeLinecap="round" [nzPercent]="progressPercent"></nz-progress>

    <ul class="flow-steps" #flowStepsContainer>
        <li *ngFor="let step of orderedSteps" [class.is-complete]="isStepComplete(step)"
            [class.is-active]="isStepActive(step)" #flowStep>
            <span class="flow-steps__dot"></span>
            <span class="flow-steps__label">{{ stepLabels[step] }}</span>
        </li>
    </ul>

    <section class="flow-stage">
        <ng-container [ngSwitch]="currentPage">
            <ng-container *ngSwitchCase="'general'">
                <app-starlink-general [fullData]="fullData" (customerData)="route($event)"></app-starlink-general>
            </ng-container>

            <ng-container *ngSwitchCase="'catalog'">
                <app-starlink-catalog [fullData]="fullData"
                    (catalogDone)="handleCatalogDone($event)"></app-starlink-catalog>
            </ng-container>

            <ng-container *ngSwitchCase="'documents'">
                <app-starlink-documents [fullData]="fullData"
                    (documentsDone)="handleDocumentsDone($event)"></app-starlink-documents>
            </ng-container>

            <ng-container *ngSwitchCase="'starlink-order'">
                <app-starlink-order [fullData]="fullData"
                    (orderDone)="handleStarlinkOrderDone($event)"></app-starlink-order>
            </ng-container>

            <ng-container *ngSwitchCase="'ihs-order'">
                <app-starlink-ihs-order [fullData]="fullData"
                    (orderDone)="handleIhsOrderDone($event)"></app-starlink-ihs-order>
            </ng-container>
        </ng-container>
    </section>
</div>